export enum PermitFilterType {
  IssuedPendingAction = 0,
  Returned = 1,
  Approved = 2,
  DeclinedCancelled = 3,
  Confirmed = 4,
}
